export const consultationsMode = {
  VIDCON_ONLY: true,
  LOCAL_ONLY: false,
  VIDCON_OR_LOCAL: false,
} as { [mode: string]: boolean };
